import { User } from "oidc-client";
import react, { useEffect, useState } from "react";
import endpoints from "../constants/endpoints";
import useApiRequest from '../services/apiRequest';
export interface IFilters {
    [x: string]: any;
    min_amount?: number,
    max_amount?: number,
    min_homolog_price?: number,
    max_homolog_price?: number,
    body?: string[],
    body_type?: string[],
    bidder_type?: string,
    bidder_name?: string,
    bidder_document?: string,
    procurement_type?: string,
    modality?: string,
    object_nature?: string,
    city?: string[],
    imediate_region?: string[],
    inter_region?: string[],
    year?: number[],
    month?: number[],
    isPeriod?: boolean,
    before?: string,
    after?: string,
    skip_duplicates?: boolean,
    base_facet?: string[],
    description_facet?: string[],
    cluster_facet?: string[],
    unit_metric_facet?: string[],
    year_facet?: string[],
    prd_serv_facet?: string[],
    relevant_facet?: string[],
    first_token_facet?: string[],
    price_range?: any[],
}

export interface IFiltersOverprice {
    [x: string]: any;
    min_amount?: number,
    max_amount?: number,
    min_cp_price?: number,
    max_cp_price?: number,
    min_rf_price?: number,
    max_rf_price?: number,
    min_diff_price?: number,
    max_diff_price?: number,
    body?: string[],
    body_type?: string[],
    bidder_type?: string,
    bidder_name?: string,
    bidder_document?: string,
    procurement_type?: string,
    modality?: string,
    object_nature?: string,
    city?: string[],
    imediate_region?: string[],
    inter_region?: string[],
    year?: number[],
    month?: number[],
    isPeriod?: boolean,
    before?: string,
    after?: string,
    base_facet?: string[],
    description_facet?: string[],
    cluster_facet?: string[],
    unit_metric_facet?: string[],
    year_facet?: string[],
    prd_serv_facet?: string[],
    relevant_facet?: string[],
    first_token_facet?: string[],
    price_range?: any[],
    base_cp?: string[],
    base_rf?: string[],
}

const defaultValue: IFilters = {
    min_amount: undefined,
    max_amount: undefined,
    min_homolog_price: undefined,
    max_homolog_price: undefined,
    body: [],
    body_type: [],
    bidder_type: "",
    bidder_name: "",
    bidder_document: "",
    procurement_type: "",
    modality: "",
    object_nature: "",
    city: [],
    imediate_region: [],
    inter_region: [],
    year: [],
    month: [],
    isPeriod: false,
    before: "",
    after: "",
    skip_duplicates: false,
    base_facet: [],
    description_facet: [],
    cluster_facet: [],
    unit_metric_facet: [],
    year_facet: [],
    prd_serv_facet: [],
    relevant_facet: [],
    first_token_facet: [],
    price_range: [],
}


type OverpriceChartProps = {
    begin: number | null;
    end: number | null;
    label: string;
}

export type FilterKey =
    "before" | "after" | "city" | "microregion" | "mesoregion" | "plan_region" |
    "imediate_region" | "inter_region" | "year" | "month" | "description" |
    "unit_measure" | "group" | "first_token" | "body" | "body_type" | "modality" |
    "procurement_type" | "bidder_name" | "bidder_type" | "bidder_document" |
    "min_amount" | "max_amount" | "min_homolog_price" | "max_homolog_price" |
    "object_nature" | "skip_duplicates" | "base_facet" | "description_facet" |
    "cluster_facet" | "first_token_facet" | "unit_metric_facet" | "year_facet" |
    "prd_serv_facet" | "relevant_facet" | "min_cp_price" | "max_cp_price" | "min_rf_price" | "max_rf_price" |
    "base_rf" | "base_cp" | "type" | "get_file" | "delete_file" | "generate_file" | "get_aggregate" | "print_list_items" |
    "usuario";

interface userPermissions {

    usuario: string,
    type: string,
    see_logs_user: boolean,
    see_logs_admin: boolean,
    create_user: boolean,
    create_admin: boolean,
    print_list_items: boolean,
    generate_file: boolean,
    get_file: boolean,
    delete_file: boolean,
    get_aggregate: boolean

}

interface globalContextInterface {
    apimToken: null,
    setApimToken: react.Dispatch<any>,
    apimExpTime: null,
    setApimExpTime: react.Dispatch<any>,
    userPermissions: userPermissions,
    setUserPermissions: react.Dispatch<userPermissions>
    description: null,
    setDescription: react.Dispatch<any>,
    descriptionOverprice: null,
    setDescriptionOverprice: react.Dispatch<any>,
    typedDescription: null,
    setTypedDescription: react.Dispatch<any>,
    typedDescriptionOverprice: null,
    setTypedDescriptionOverprice: react.Dispatch<any>,
    searchTerm: null,
    setSearchTerm: react.Dispatch<any>,
    searchTermOverprice: null,
    setSearchTermOverprice: react.Dispatch<any>,
    searchType: string,
    setSearchType: react.Dispatch<any>,
    typedSearchType: string,
    setTypedSearchType: react.Dispatch<any>
    filters: IFilters,
    setFilters: react.Dispatch<IFilters>
    filtersOverprice: IFiltersOverprice,
    setFiltersOverprice: react.Dispatch<IFiltersOverprice>
    typedFilters: IFilters
    setTypedFilters: react.Dispatch<IFilters>
    typedFiltersOverprice: IFiltersOverprice
    setTypedFiltersOverprice: react.Dispatch<IFiltersOverprice>
    openReportsDialog: boolean
    setOpenReportsDialog: react.Dispatch<boolean>
    selectAll: boolean
    setSelectAll: react.Dispatch<any>
    overpriceChartFilter: OverpriceChartProps[]
    setOverpriceChartFilter: react.Dispatch<any>
    overpriceChartFilterAux: OverpriceChartProps[]
    setOverpriceChartFilterAux: react.Dispatch<any>
    countFilters: () => number
    cleanFilters: () => void
    countFiltersOverprice: () => number
    cleanFiltersOverprice: () => void
    cleanFacetsFilters: () => void
    currentUser: User | null,
    setCurrentUser: react.Dispatch<react.SetStateAction<User | null>>
    currentPage: number
    setCurrentPage: react.Dispatch<any>
    pageSize: number
    setPageSize: react.Dispatch<any>
    currentPageFacet: number
    setCurrentPageFacet: react.Dispatch<any>
    pageSizeFacet: number
    setPageSizeFacet: react.Dispatch<any>
    selectedFacets: any[]
    setSelectedFacets: react.Dispatch<any>
    selectedRowsFacet: any[]
    setSelectedRowsFacet: react.Dispatch<any>
    searchValues: SearchBlock[],
    setSearchValues: react.Dispatch<react.SetStateAction<SearchBlock[]>>
    clearSearch: () => void
    translateFilter: (filterKey: FilterKey) => string
};


export const emptySearchBlock: SearchBlock = {
    operator: "or",
    searchValues: [
        {
            operator: "or",
            mapping: "at-least-one",
            query: ""
        }
    ]
};

export const GlobalStateContext = react.createContext<globalContextInterface>({} as globalContextInterface);

type Props = {
    children: JSX.Element
}

function GlobalContext({ children }: Props) {
    const { get, getApimToken } = useApiRequest();
    const [apimToken, setApimToken] = useState<any>(null);
    const [apimExpTime, setApimExpTime] = useState<any>(null);
    const tokenRefreshInterval = 60 * 1000;
    const [token, setToken] = useState('');

    const [descriptionOverprice, setDescriptionOverprice] = useState<any>(null);
    const [description, setDescription] = useState<any>(null);

    const [searchType, setSearchType] = useState<string>("smart");
    const [typedSearchType, setTypedSearchType] = useState(searchType)
    const [currentUser, setCurrentUser] = useState<User | null>(null);
    const [filters, setFilters] = useState<IFilters>({
        base_facet: [],
        description_facet: [],
        cluster_facet: [],
        unit_metric_facet: [],
        year_facet: [],
        prd_serv_facet: [],
        relevant_facet: [],
        first_token_facet: [],
    });

    const [filtersOverprice, setFiltersOverprice] = useState<IFiltersOverprice>({
        base_facet: [],
        description_facet: [],
        cluster_facet: [],
        unit_metric_facet: [],
        year_facet: [],
        prd_serv_facet: [],
        relevant_facet: [],
        first_token_facet: [],
    });


    const [selectAll, setSelectAll] = useState(false);

    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(100);

    const [currentPageFacet, setCurrentPageFacet] = useState<number>(0);
    const [pageSizeFacet, setPageSizeFacet] = useState<number>(10);
    const [selectedFacets, setSelectedFacets] = useState<any[]>([]);
    const [selectedRowsFacet, setSelectedRowsFacet] = useState<any[]>([]);



    const [typedDescription, setTypedDescription] = useState<any>("");
    const [typedDescriptionOverprice, setTypedDescriptionOverprice] = useState<any>("");

    const [searchTerm, setSearchTerm] = useState(typedDescription || "");
    const [searchTermOverprice, setSearchTermOverprice] = useState(typedDescriptionOverprice || "");

    const [typedFilters, setTypedFilters] = useState<IFilters>({
        base_facet: [],
        description_facet: [],
        cluster_facet: [],
        unit_metric_facet: [],
        year_facet: [],
        prd_serv_facet: [],
        relevant_facet: [],
        first_token_facet: [],
    });

    const [typedFiltersOverprice, setTypedFiltersOverprice] = useState<IFiltersOverprice>({
        base_facet: [],
        description_facet: [],
        cluster_facet: [],
        unit_metric_facet: [],
        year_facet: [],
        prd_serv_facet: [],
        relevant_facet: [],
        first_token_facet: [],
    });

    const [openReportsDialog, setOpenReportsDialog] = useState(false);


    const [overpriceChartFilter, setOverpriceChartFilter] = useState([]);
    const [overpriceChartFilterAux, setOverpriceChartFilterAux] = useState([]);

    const [searchValues, setSearchValues] = useState<SearchBlock[]>([{
        operator: "or",
        searchValues: [
            {
                operator: "or",
                mapping: "at-least-one",
                query: ""
            }
        ]
    }]);

    const clearSearchEvent = new Event("clearSearch");
    const clearSearch = () => {
        setTypedDescription("");
        setSearchValues([{
            operator: "or",
            searchValues: [
                {
                    operator: "or",
                    mapping: "at-least-one",
                    query: ""
                }
            ]
        }])
        document.dispatchEvent(clearSearchEvent);
    }

    const countFilters = (): number => {
        let count = 0;
        if (filters.min_amount) count++;
        if (filters.max_amount) count++;
        if (filters.min_homolog_price) count++;
        if (filters.max_homolog_price) count++;
        if (filters.body) count++;
        if (filters.bidder_document) count++;
        if (filters.procurement_type) count++;
        if (filters.modality) count++;
        if (filters.object_nature) count++;
        if (filters.skip_duplicates) count++;
        if (filters.city) {
            if (filters.city.length > 0) {
                count++;
            }
        }
        if (filters.month) {
            if (filters.month.length > 0) {
                count++;
            }
        }
        if (filters.year) {
            if (filters.year.length > 0) {
                count++;
            }
        }
        return count;
    }

    const countFiltersOverprice = (): number => {
        let count = 0;
        if (filtersOverprice.min_amount) count++;
        if (filtersOverprice.max_amount) count++;
        if (filtersOverprice.min_cp_price) count++;
        if (filtersOverprice.max_cp_price) count++;
        if (filtersOverprice.min_rf_price) count++;
        if (filtersOverprice.max_rf_price) count++;
        if (filtersOverprice.min_diff_price) count++;
        if (filtersOverprice.max_diff_price) count++;
        if (filtersOverprice.body) count++;
        if (filtersOverprice.bidder_document) count++;
        if (filtersOverprice.procurement_type) count++;
        if (filtersOverprice.modality) count++;
        if (filtersOverprice.object_nature) count++;
        if (filtersOverprice.skip_duplicates) count++;
        if (filtersOverprice.city) {
            if (filtersOverprice.city.length > 0) {
                count++;
            }
        }
        if (filtersOverprice.month) {
            if (filtersOverprice.month.length > 0) {
                count++;
            }
        }
        if (filtersOverprice.year) {
            if (filtersOverprice.year.length > 0) {
                count++;
            }
        }
        if (filtersOverprice.base_cp) {
            if (filtersOverprice.base_cp.length > 0) {
                count++;
            }
        }
        if (filtersOverprice.base_rf) {
            if (filtersOverprice.base_rf.length > 0) {
                count++;
            }
        }
        return count;
    }

    const cleanFilters = () => {
        setTypedFilters({
            base_facet: [],
            description_facet: [],
            cluster_facet: [],
            unit_metric_facet: [],
            year_facet: [],
            prd_serv_facet: [],
            relevant_facet: [],
            first_token_facet: [],

        });
        setFilters({
            base_facet: [],
            description_facet: [],
            cluster_facet: [],
            unit_metric_facet: [],
            year_facet: [],
            prd_serv_facet: [],
            relevant_facet: [],
            first_token_facet: [],

        });

        setSelectedFacets([]);
    }

    const cleanFiltersOverprice = () => {
        setTypedFiltersOverprice({
            base_facet: [],
            description_facet: [],
            cluster_facet: [],
            unit_metric_facet: [],
            year_facet: [],
            prd_serv_facet: [],
            relevant_facet: [],
            first_token_facet: [],

        });
        setFiltersOverprice({
            base_facet: [],
            description_facet: [],
            cluster_facet: [],
            unit_metric_facet: [],
            year_facet: [],
            prd_serv_facet: [],
            relevant_facet: [],
            first_token_facet: [],

        });
    }


    const cleanFacetsFilters = () => {
        setTypedFilters({
            min_amount: typedFilters.min_amount,
            max_amount: typedFilters.max_amount,
            min_homolog_price: typedFilters.min_homolog_price,
            max_homolog_price: typedFilters.max_homolog_price,
            body: typedFilters.body,
            body_type: typedFilters.body_type,
            bidder_type: typedFilters.bidder_type,
            bidder_name: typedFilters.bidder_name,
            bidder_document: typedFilters.bidder_document,
            procurement_type: typedFilters.procurement_type,
            modality: typedFilters.modality,
            object_nature: typedFilters.object_nature,
            city: typedFilters.city,
            imediate_region: typedFilters.imediate_region,
            inter_region: typedFilters.inter_region,
            year: typedFilters.year,
            month: typedFilters.month,
            isPeriod: typedFilters.isPeriod,
            before: typedFilters.before,
            after: typedFilters.after,
            skip_duplicates: typedFilters.skip_duplicates,
            base_facet: [],
            description_facet: [],
            cluster_facet: [],
            unit_metric_facet: [],
            year_facet: [],
            prd_serv_facet: [],
            relevant_facet: [],
            first_token_facet: [],
        });
    }


    const translations: Record<FilterKey, string> = {
        before: "Antes de",
        after: "Depois de",
        city: "Cidade",
        microregion: "Microrregião",
        mesoregion: "Mesorregião",
        plan_region: "Região de Planejamento",
        imediate_region: "Região Imediata",
        inter_region: "Região Intermediária",
        year: "Ano",
        month: "Mês",
        description: "Descrição",
        unit_measure: "Unidade de Medida",
        group: "Grupo",
        first_token: "Primeiro Trmo",
        body: "Orgão",
        body_type: "Tipo de Orgão",
        modality: "Modalidade",
        procurement_type: "Tipo de Licitação",
        bidder_name: "Fornecedor",
        bidder_type: "Tipo",
        bidder_document: "CNPJ",
        min_amount: "Quantidade Comprada Mínima",
        max_amount: "Quantidade Comprada Máxima",
        min_homolog_price: "Preço Unitário Mínimo",
        max_homolog_price: "Preço Unitário Máximo",
        object_nature: "Natureza do Objeto",
        skip_duplicates: "Remover Duplicidades",
        base_facet: "Fonte de dados",
        description_facet: "Descrição",
        cluster_facet: "Descrição Processada",
        first_token_facet: "Primeiro Termo",
        unit_metric_facet: "Unidade de Medida",
        year_facet: "Ano",
        prd_serv_facet: "Produto/Serviço",
        relevant_facet: "Termo Relevante",
        min_cp_price: "Preço de CP Mínimo",
        max_cp_price: "Preço de CP Máximo",
        min_rf_price: "Preço de RF mínimo",
        max_rf_price: "Preço de RF máximo",
        base_cp: "Base de CP",
        base_rf: "Base de RF",
        type: "Tipo",
        get_file: "Baixar arquivo",
        delete_file: "Apagar arquivo",
        generate_file: "Gerar arquivo",
        get_aggregate: "Calcular sobrepreço",
        print_list_items: "Fazer busca",
        usuario: "Usuário"
    };

    const translateFilter = (filterKey: FilterKey): string => {
        return translations[filterKey] || filterKey;
    }




    const [userPermissions, setUserPermissions] = useState<userPermissions>({
        usuario: "",
        type: "",
        see_logs_user: false,
        see_logs_admin: false,
        create_user: false,
        create_admin: false,
        print_list_items: false,
        generate_file: false,
        get_file: false,
        delete_file: false,
        get_aggregate: false
    } as userPermissions)


    return <GlobalStateContext.Provider value={{ apimToken, setApimToken, apimExpTime, setApimExpTime, userPermissions, setUserPermissions, description, setDescriptionOverprice, typedDescription, setTypedDescription, descriptionOverprice, setDescription, typedDescriptionOverprice, setTypedDescriptionOverprice, searchTerm, setSearchTerm, searchTermOverprice, setSearchTermOverprice, searchType, setSearchType, typedSearchType, setTypedSearchType, filters, setFilters, filtersOverprice, setFiltersOverprice, typedFilters, setTypedFilters, typedFiltersOverprice, setTypedFiltersOverprice, overpriceChartFilter, setOverpriceChartFilter, overpriceChartFilterAux, setOverpriceChartFilterAux, countFilters, cleanFilters, countFiltersOverprice, cleanFiltersOverprice, cleanFacetsFilters, currentUser, setCurrentUser, currentPage, setCurrentPage, pageSize, setPageSize, currentPageFacet, setCurrentPageFacet, pageSizeFacet, setPageSizeFacet, selectAll, setSelectAll, searchValues, setSearchValues, clearSearch, openReportsDialog, setOpenReportsDialog, selectedFacets, setSelectedFacets, selectedRowsFacet, setSelectedRowsFacet, translateFilter }}>
        {children}
    </GlobalStateContext.Provider>
}

export default GlobalContext;
